<template lang="pug">
  v-dialog(v-model="dialog" persistent width="600" @keydown.esc="closeDialog")
    v-card
      v-toolbar(dark :color="$store.getters['site/siteColor']")
        v-icon(left color="white darken-2" large) help
        span  {{ title }}
        v-spacer
        v-btn(flat icon @click="closeDialog")
          v-icon close

      v-card-text
        v-layout
          v-flex
            v-card(flat)
              v-card-text
                v-layout(row wrap)
                  v-flex(xs12)
                    AlertBox(ref="alertBox")
                  v-flex(xs12)
                    //失注理由
                    OrderLossStatusSelect(:code.sync="record.lostOrderReason" :multiple="false" :clearable="false"
                      :errorHandlerMethod="getErrorMessages")
                  v-flex(xs12)
                    //失注理由その他
                    v-textarea(label="失注理由その他" auto-grow v-model="record.lostOrderReasonOther"
                      :error-messages="getErrorMessages('lostOrderReasonOther')")


      v-toolbar.footer
        slot(name="footer")
          v-spacer
          v-btn(color="" @click="no") {{ noButtonTitle }}
          v-btn(color="primary" @click="yes") {{ yesButtonTitle }}
</template>

<script>
import OrderLossStatusSelect from "@/components/common/select/OrderLossStatusSelect.vue";
import { useApiHandler } from "@/composables/api/useApiHandler";
import AlertBox from "@/components/common/AlertBox.vue";

export default {
  setup(props, { emit }) {
    const { saveRecord, deleteRecord, setErrorMessages, getErrorMessages, clearErrorMessages, loading } =
      useApiHandler(
        props.postUrl,
        props.deleteUrl,
        (response, data) => {
          emit("updated", response, data);
        },
        response => {
          emit("deleted", response);
        }
      );

    return {
      saveRecord,
      deleteRecord,
      setErrorMessages,
      getErrorMessages,
      clearErrorMessages,
      loading
    };
  },
  components: { AlertBox, OrderLossStatusSelect },
  props: {
    title: {
      type: String,
      required: false,
      default: "失注確認"
    },
    yesButtonTitle: {
      type: String,
      required: false,
      default: "送信"
    },
    noButtonTitle: {
      type: String,
      required: false,
      default: "キャンセル"
    },
    provisionalOrderCardId: {
      type: Number,
      required: false,
      default() {
        return null;
      }
    },
    requestParams: {
      type: Object,
      required: false,
      default() {
        return undefined;
      }
    },
    postUrl: {
      type: String,
      default() {
        return "defaultPost";
      }
    },
    deleteUrl: {
      type: String,
      default() {
        return "defaultDelete";
      }
    }
  },
  data() {
    return {
      dialog: false,
      text: null,
      record: {
        lostOrderReason: null,
        lostOrderReasonOther: null
      }
    };
  },
  methods: {
    openDialog() {
      this.clearAlertMessage();
      this.clearErrorMessages();
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    no() {
      this.closeDialog();
    },
    clearAlertMessage() {
      this.$refs.alertBox.nonDisplayMessage();
    },
    async yes() {
      this.clearAlertMessage();
      this.clearErrorMessages();

      let tranData;
      if (this.requestParams !== undefined) {
        tranData = Object.assign({}, this.record, this.requestParams);
      } else {
        tranData = Object.assign({}, this.record, {
          provisionalOrderCardId: this.provisionalOrderCardId
        });
      }

      try {
        var response = await this.saveRecord(tranData);
        this.$emit("saved", response.data.data);
        this.closeDialog();
      } catch (error) {
        // if (error.response.data["fieldErrors"] == null) {
        //   this.$refs.alertBox.displayMessage(error.response.data.message);
        // }
      }
    }
  }
};
</script>
